export default class CleanUpProposalStateError extends Error {
    
}
